import { reactive } from 'vue';
import { GeoStatus } from 'choco-app';
import { KEYS, PLATFORMS } from './types';
import { DOCUMENT_TITLE } from '@/utils/constants';
import { application } from '@/utils/plugins/di/providers';
import i18n from '@/utils/plugins/i18n';
import { getContractTownId } from '@/utils/functions/get-contract-town-id';
import type { ICoordinates, IService } from '@/types/interfaces/common';

const storage = window.localStorage;

interface IState {
	townId: number;
	platform: PLATFORMS;
	version: string;
	deviceId: string;
	geoStatus: GeoStatus;
	coordinates: ICoordinates | null;
	title: string;
	service: IService;
}

/**
 * Получения сервиса по умолчанию
 */
const getDefaultService = (): IService => {
	const id: string = localStorage.getItem(KEYS.SERVICE) || '';
	return application.getServiceById(id);
};

/**
 * Получение города по умолчанию.
 * Сохраненный город не подходит, если партнер в нем не работает —
 * тогда берется город из контракта партнера
 */
const getDefaultTownId = (): number => {
	const storedTownId = Number(storage.getItem(KEYS.TOWN_ID)) || null;
	const townId = getContractTownId(storedTownId, application.getCustomConfig());

	if (townId !== storedTownId) {
		storage.setItem(KEYS.TOWN_ID, `${townId}`);
	}

	return townId;
};

const state = reactive<IState>({
	townId: getDefaultTownId(),
	platform: (storage.getItem(KEYS.PLATFORM) as PLATFORMS) || PLATFORMS.WEB,
	version: storage.getItem(KEYS.VERSION) || '',
	deviceId: storage.getItem(KEYS.DEVICE_ID) || '',
	geoStatus: GeoStatus.granted,
	coordinates: null,
	title: i18n.global.t(DOCUMENT_TITLE),
	service: getDefaultService()
});

export { IState, state };
